import React, { useState } from "react";
import config from "../../config";
import StrapiLightbox from "../StrapiLightbox";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

const MediaGallery = ({ description, title, images }) => {
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  const handleImageClick = (index) => {
    setLightboxIndex(index);
  };
  return (
    <>
      <h2>{title}</h2>
      <div className="container d-flex flex-wrap justify-content-center gap-2">
        {images?.map((image, index) => (
          <div
            className="m-2 col-10 col-md-3 d-flex justify-content-center"
            key={index}
          >
            <img
              key={image.id}
              src={`${config.api}${image?.url}`}
              alt={image.name}
              onClick={() => handleImageClick(index)}
              className="media-thumbnail media-gallery"
              style={{ cursor: "pointer" }}
            />
          </div>
        ))}
        <StrapiLightbox
          images={images}
          index={lightboxIndex}
          setIndex={setLightboxIndex}
        />
      </div>
      <BlocksRenderer
        content={Array.isArray(description) ? description : []}
        blocks={{
          image: ({ image }) => (
            <img
              src={image.url}
              alt={image.alternativeText}
              className="blocks-renderer-img"
            />
          ),
          list: ({ children, format }) =>
            format === "unordered" ? (
              <ul className="blocks-renderer-ul">{children}</ul>
            ) : (
              <ol className="blocks-renderer-ol">{children}</ol>
            ),
        }}
      ></BlocksRenderer>
    </>
  );
};

export default MediaGallery;
